module.exports = __webpack_public_path__ + "static/planet6-d70dc41e0d59329e25d4a00f70c5b8a9.png";